// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8b674fb6","455":"3c52a53a","977":"deeb6014"}[chunkId] + ".chunk.js";
};